/**
 *
 * Overnight Stats widget container
 * Fetch data & render spinner/error/content depending on state
 *
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import overnightStatsModule from 'containers/App/data/endpoints/overnightStats';

import messages from './messages';
import { defaultLayout } from 'containers/widgets/Widget/propTypes';

import Widget from 'containers/widgets/Widget/Widget';
import OvernightStats from './OvernightStats';
import session from 'containers/App/session';

const OvernightStatsWrapper = ({ layout = defaultLayout, filters }) => {
    const dispatch = useDispatch();

    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const stats = useSelector(overnightStatsModule.selectors.selectState);

    const fetchData = () => {
        const { startDate, endDate } = filters;
        dispatch(overnightStatsModule.actions.fetch(propertyId, startDate, endDate));
    };

    useEffect(() => {
        fetchData();
    }, [propertyId, filters]);

    const state = {
        fetching: stats.fetching,
        error: stats.error,
        fetched: stats.fetched,
    };

    return (
        <Widget layout={layout} state={state} titleMessage={messages.title} retry={fetchData}>
            <OvernightStats rawData={stats.data} />
        </Widget>
    );
};

export default OvernightStatsWrapper;
